import { AfterViewInit, Directive, inject } from '@angular/core';
import { Keyboard } from '@capacitor/keyboard';
import { IonContent } from '@ionic/angular';

@Directive({
  selector: '[cKeyboardScrollIntoView]',
  standalone: true
})
export class KeyboardScrollIntoViewDirective implements AfterViewInit {
  private readonly ionContent = inject(IonContent);
  private scrollEl?: HTMLElement;
  private showSub?: { remove: () => void };

  async ngAfterViewInit() {
    this.scrollEl = await this.ionContent.getScrollElement();
    this.showSub = await Keyboard.addListener('keyboardDidShow', () => {
      // timeout to wait for the keyboard animation and Ionic's scrolling to finish
      setTimeout(() => this.scrollFocusedIntoView(), 500);
    });
  }

  ngOnDestroy(): void {
    this.showSub?.remove();
  }

  private scrollFocusedIntoView() {
    if (!this.scrollEl) return;
    const active = document.activeElement as HTMLElement;
    if (!active) return;
    const input = active.closest('ion-input, ion-textarea, input, textarea') as HTMLElement;    
    if (!input) return;
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}